import { css, createGlobalStyle } from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { SalesforceChatStyle } from './SalesforceChatStyle'

const normalizeStyle = css`
  /* normalize.css v3.0.2 | MIT License | git.io/normalize */
  /**
     * 1. Set default font family to sans-serif.
     * 2. Prevent iOS text size adjust after orientation change, without disabling
     *    user zoom.
     */
  html {
    font-family: sans-serif;
    /* 1 */
    -ms-text-size-adjust: 100%;
    /* 2 */
    -webkit-text-size-adjust: 100%;
    /* 2 */
  }

  /**
     * Remove default margin.
     */
  body {
    margin: 0;
  }

  /* HTML5 display definitions
       ========================================================================== */
  /**
     * Correct \`block\` display not defined for any HTML5 element in IE 8/9.
     * Correct \`block\` display not defined for \`details\` or \`summary\` in IE 10/11
     * and Firefox.
     * Correct \`block\` display not defined for \`main\` in IE 11.
     */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }

  /**
     * 1. Correct \`inline-block\` display not defined in IE 8/9.
     * 2. Normalize vertical alignment of \`progress\` in Chrome, Firefox, and Opera.
     */
  audio,
  canvas,
  progress,
  video {
    display: inline-block;
    /* 1 */
    vertical-align: baseline;
    /* 2 */
  }

  /**
     * Prevent modern browsers from displaying \`audio\` without controls.
     * Remove excess height in iOS 5 devices.
     */
  audio:not([controls]) {
    display: none;
    height: 0;
  }

  /**
     * Address \`[hidden]\` styling not present in IE 8/9/10.
     * Hide the \`template\` element in IE 8/9/11, Safari, and Firefox < 22.
     */
  [hidden],
  template {
    display: none;
  }

  /* Links
       ========================================================================== */
  /**
     * Remove the gray background color from active links in IE 10.
     */
  a {
    background-color: transparent;
  }

  /**
     * Improve readability when focused and also mouse hovered in all browsers.
     */
  a:active,
  a:hover {
    outline: 0;
  }

  /* Text-level semantics
       ========================================================================== */
  /**
     * Address styling not present in IE 8/9/10/11, Safari, and Chrome.
     */
  abbr[title] {
    border-bottom: 1px dotted;
  }

  /**
     * Address style set to \`bolder\` in Firefox 4+, Safari, and Chrome.
     */
  b,
  strong {
    font-weight: bold;
  }

  /**
     * Address styling not present in Safari and Chrome.
     */
  dfn {
    font-style: italic;
  }

  /**
     * Address variable \`h1\` font-size and margin within \`section\` and \`article\`
     * contexts in Firefox 4+, Safari, and Chrome.
     */
  h1 {
    margin: 0.67em 0;

    font-size: 2em;
  }

  /**
     * Address styling not present in IE 8/9.
     */
  mark {
    color: ${getToken('color-neutral-darkest')};

    background: ${getToken('color-warning')};
  }

  /**
     * Address inconsistent and variable font size in all browsers.
     */
  small {
    font-size: 80%;
  }

  /**
     * Prevent \`sub\` and \`sup\` affecting \`line-height\` in all browsers.
     */
  sub,
  sup {
    position: relative;

    font-size: 75%;
    line-height: 0;
    vertical-align: baseline;
  }

  sup {
    top: -0.5em;
  }

  sub {
    bottom: -0.25em;
  }

  /* Embedded content
       ========================================================================== */
  /**
     * Remove border when inside \`a\` element in IE 8/9/10.
     */
  img {
    border: 0;
  }

  /**
     * Correct overflow not hidden in IE 9/10/11.
     */
  svg:not(:root) {
    overflow: hidden;
  }

  /* Grouping content
       ========================================================================== */
  /**
     * Address margin not present in IE 8/9 and Safari.
     */
  figure {
    margin: 1em 40px;
  }

  /**
     * Address differences between Firefox and other browsers.
     */
  hr {
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    height: 0;
  }

  /**
     * Contain overflow in all browsers.
     */
  pre {
    overflow: auto;
  }

  /**
     * Address odd \`em\`-unit font size rendering in all browsers.
     */
  code,
  kbd,
  pre,
  samp {
    font-size: 1em;
    font-family: monospace;
  }

  /* Forms
       ========================================================================== */
  /**
     * Known limitation: by default, Chrome and Safari on OS X allow very limited
     * styling of \`select\`, unless a \`border\` property is set.
     */
  /**
     * 1. Correct color not being inherited.
     *    Known issue: affects color of disabled elements.
     * 2. Correct font properties not being inherited.
     * 3. Address margins set differently in Firefox 4+, Safari, and Chrome.
     */
  button,
  input,
  optgroup,
  select,
  textarea {
    /* 2 */
    margin: 0;

    color: inherit;
    /* 1 */
    font: inherit;
    /* 3 */
  }

  /**
     * Address \`overflow\` set to \`hidden\` in IE 8/9/10/11.
     */
  button {
    overflow: visible;
  }

  /**
     * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
     * All other form control elements do not inherit \`text-transform\` values.
     * Correct \`button\` style inheritance in Firefox, IE 8/9/10/11, and Opera.
     * Correct \`select\` style inheritance in Firefox.
     */
  button,
  select {
    text-transform: none;
  }

  /**
     * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
     *    and \`video\` controls.
     * 2. Correct inability to style clickable \`input\` types in iOS.
     * 3. Improve usability and consistency of cursor style between image-type
     *    \`input\` and others.
     */
  button,
  html input[type='button'],
  input[type='reset'],
  input[type='submit'] {
    /* 2 */
    cursor: pointer;

    -webkit-appearance: button;
    /* 3 */
  }

  /**
     * Re-set default cursor for disabled elements.
     */
  button[disabled],
  html input[disabled] {
    cursor: default;
  }

  /**
     * Address Firefox 4+ setting \`line-height\` on \`input\` using \`!important\` in
     * the UA stylesheet.
     */

  input {
    line-height: normal;
  }

  /**
     * Remove inner padding and border in Firefox 4+.
     */
  button::-moz-focus-inner,
  input::-moz-focus-inner {
    padding: 0;

    border: 0;
  }

  /**
     * It's recommended that you don't attempt to style these elements.
     * Firefox's implementation doesn't respect box-sizing, padding, or width.
     *
     * 1. Address box sizing set to \`content-box\` in IE 8/9/10.
     * 2. Remove excess padding in IE 8/9/10.
     */
  input[type='checkbox'],
  input[type='radio'] {
    box-sizing: border-box;
    /* 1 */
    padding: 0;
    /* 2 */
  }

  /**
     * Fix the cursor style for Chrome's increment/decrement buttons. For certain
     * \`font-size\` values of the \`input\`, it causes the cursor style of the
     * decrement button to change from \`default\` to \`text\`.
     */
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    height: auto;

    -webkit-appearance: none;
  }

  /**
     * 1. Address \`appearance\` set to \`searchfield\` in Safari and Chrome.
     * 2. Address \`box-sizing\` set to \`border-box\` in Safari and Chrome
     *    (include \`-moz\` to future-proof).
     */
  input[type='search'] {
    /* 1 */
    -moz-box-sizing: content-box;
    -webkit-box-sizing: content-box;
    /* 2 */
    box-sizing: content-box;

    -webkit-appearance: textfield;
  }

  /**
     * Remove inner padding and search cancel button in Safari and Chrome on OS X.
     * Safari (but not Chrome) clips the cancel button when the search input has
     * padding (and \`textfield\` appearance).
     */
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
     * Define consistent border, margin, and padding.
     */
  fieldset {
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;

    border: 1px solid ${getToken('color-neutral-light')};
  }

  /**
     * 1. Correct \`color\` not being inherited in IE 8/9/10/11.
     * 2. Remove padding so people aren't caught out if they zero out fieldsets.
     */
  legend {
    /* 1 */
    padding: 0;

    border: 0;
    /* 2 */
  }

  /**
     * Remove default vertical scrollbar in IE 8/9/10/11.
     */
  textarea {
    overflow: auto;
  }

  /**
     * Don't inherit the \`font-weight\` (applied by a rule above).
     * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.
     */
  optgroup {
    font-weight: bold;
  }

  /* Tables
       ========================================================================== */
  /**
     * Remove most spacing between table cells.
     */
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  td,
  th {
    padding: 0;
  }
`

const uiStyle = css`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  :root {
    --navbar-height: 50px;
    --page-wrapper-offset: var(--navbar-height);
  }

  dl,
  menu,
  ol,
  fieldset,
  ul {
    margin: 0;
    padding: 0;
  }

  li {
    list-style: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  figure {
    margin: 0;
  }

  button:focus {
    outline: 0;
  }

  a {
    text-decoration: none;
  }

  input[type='text'],
  input[type='email'],
  input[type='search'],
  input[type='password'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  select {
    text-indent: 0.01px;
    text-overflow: '';

    -moz-appearance: none;
  }

  input::-ms-clear {
    display: none;
  }

  body {
    font-family: Manrope, Helvetica, Arial, sans-serif;
    background: ${getToken('color-neutral-lightest')};
  }
`

const mediaPrint = css`
  @page {
    size: auto;

    margin: 0;

    page-break-after: auto;
  }

  @media print {
    body {
      margin: 0;

      background-color: ${getToken('color-neutral-white')};
    }
  }
`

const vendor = css`
  .Toastify__toast--success {
    background: ${getToken('color-primary')};
    border-radius: 5px;
    font-weight: 500;
    text-align: center;
  }

  .Toastify__toast--error {
    background: ${getToken('color-danger')};
    border-radius: 5px;
    font-weight: 500;
    text-align: center;
  }

  .ReactModalPortal > div {
    opacity: 0;
  }

  .ReactModal__Body--open {
    overflow: hidden;
  }

  .ReactModalPortal .ReactModal__Overlay {
    z-index: 10000 !important;

    background-color: rgba(0, 0, 0, 0.5) !important;

    transition: opacity 200ms ease-in-out;
  }

  .ReactModalPortal .ReactModal__Overlay--after-open {
    opacity: 1;
  }

  .ReactModalPortal .ReactModal__Overlay--before-close {
    opacity: 0;
  }

  .ls-Dialog {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;

    overflow: auto;

    color: ${getToken('color-neutral-darker')};
    font-size: 14px;
    font-family: Manrope, Helvetica, Arial, sans-serif;
    -webkit-overflow-scrolling: touch;
  }

  .ls-Dialog p {
    margin-bottom: 20px;

    line-height: 20px;
  }

  .ls-Dialog-content {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100vh;
    margin-left: 0;
    padding: 90px 20px 23px;
    overflow: auto;

    background: ${getToken('color-neutral-lightest')};
    -webkit-backface-visibility: hidden;

    transition: height 750ms linear;

    will-change: height;
  }

  @media screen and (min-width: 768px) {
    .ls-Dialog-content {
      top: 60px;
      left: 50%;

      width: 340px;
      height: auto;
      margin-left: -175px;
      padding: 90px 30px 23px;
      overflow: initial;

      border-radius: 4px;
    }
  }

  .ls-Dialog-close {
    position: absolute;
    top: 18px;
    right: 5px;
    z-index: 50;

    padding: 2px 6px 4px 9px;

    color: ${getToken('color-neutral')};
    font-weight: 700;
    font-size: 40px;
    line-height: 24px;
    text-align: center;
    vertical-align: middle;

    background-color: transparent;
  }

  .ls-Dialog-close:hover {
    opacity: 0.7;
  }

  @media screen and (min-width: 768px) {
    .ls-Dialog-close {
      top: -8px;
      right: -11px;
      z-index: 100;

      padding: 2px 6px 3px 7px;

      font-size: 25px;

      background-color: rgba(50, 50, 50, 0.8);
      border-radius: 50%;
    }
  }

  .ReactModalPortal .ls-Dialog-close {
    padding: 2px 1px 2px 8px;

    border: 0;
  }

  .ls-Dialog-close:before {
    cursor: pointer;

    content: '\\00D7';
  }
`

export const GlobalStyle = createGlobalStyle`
    ${normalizeStyle}
    ${uiStyle}
    ${mediaPrint}
    ${vendor}
    ${SalesforceChatStyle}
`
